"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPanelWishlistView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const utils_1 = require("@obvio/utils");
const image_1 = __importDefault(require("next/image"));
const UserPanelSectionView_1 = require("./UserPanelSectionView");
const EmptyInfo_1 = require("../../EmptyInfo");
const useWishlist_1 = require("../../lib/hooks/useWishlist");
const ImageWrap = (0, app_1.styled)(app_1.Link) `
  border: 1px solid ${(theme) => theme.stroke};
  border-radius: ${(theme) => theme.radius.small};
  overflow: hidden;
  position: relative;
  :hover {
    > button {
      opacity: 1;
    }
  }
`;
const StyledImage = (0, app_1.styled)(image_1.default) `
  transition: 500ms all;
  object-fit: contain;
  :hover {
    transform: scale(1.05);
  }
`;
const ProductTitle = (0, app_1.styled)(app_1.Text) `
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.015625rem;
`;
const ProductPrice = app_1.styled.span `
  font-weight: 700;
  font-size: 0.9375rem;
  color: #000000;
  letter-spacing: 0.00625rem;
  line-height: 150%;
`;
const RemoveButton = (0, app_1.styled)(ui_1.Button) `
  position: absolute;
  right: ${(theme) => theme.spacing.small};
  bottom: ${(theme) => theme.spacing.small};
  background: ${(theme) => theme.stroke};
  height: 3rem;
  width: 3rem;
  border-radius: ${(theme) => theme.radius.small};
  color: ${(theme) => theme.colors.gray.semidark};
  opacity: 0;

  @media ${app_1.mobile} {
    opacity: 1;
    height: 3rem;
    width: 3rem;
  }
`;
const ProductsGrid = (0, app_1.styled)(ui_1.Grid) `
  grid-template-columns: minmax(0, 1fr);

  @media ${app_1.desktop} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media ${app_1.bigScreen} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;
function WishlistItem({ product }) {
    var _a, _b, _c, _d;
    const { removeFromWishlist } = (0, useWishlist_1.useWishlist)();
    const contextPath = (0, app_1.useContextPath)('ecommerce.product');
    const imageSources = (_a = product === null || product === void 0 ? void 0 : product.images) === null || _a === void 0 ? void 0 : _a.map((img) => `${contextPath}/${product.id}/${img === null || img === void 0 ? void 0 : img.name}`);
    const productPath = `${contextPath}/${product ? product.slug : ''}`;
    const handleClick = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        return removeFromWishlist({ productId: product.id });
    };
    const contactOnly = !((_b = product === null || product === void 0 ? void 0 : product.price) === null || _b === void 0 ? void 0 : _b.price);
    return ((0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical", spacing: "small" }, { children: [(0, jsx_runtime_1.jsxs)(ImageWrap, Object.assign({ href: productPath }, { children: [(0, jsx_runtime_1.jsx)(StyledImage, { src: imageSources[0], alt: (_c = product === null || product === void 0 ? void 0 : product.title) !== null && _c !== void 0 ? _c : '', layout: "responsive", width: 320, height: 320, quality: 85 }), (0, jsx_runtime_1.jsx)(RemoveButton, Object.assign({ kind: "icon", onClick: handleClick }, { children: (0, jsx_runtime_1.jsx)(svg_1.SvgBin, {}) }))] })), (0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical", spacing: "0.1rem" }, { children: [(0, jsx_runtime_1.jsx)(ProductTitle, Object.assign({ tag: "h3" }, { children: product.title })), contactOnly ? null : ((0, jsx_runtime_1.jsx)(ProductPrice, { children: (0, utils_1.formatPrice)((_d = product.price) === null || _d === void 0 ? void 0 : _d.price) }))] }))] })));
}
function UserPanelWishlistView({ products, loading, }) {
    const { t } = (0, app_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(UserPanelSectionView_1.UserPanelSectionView, Object.assign({ title: t('store.wishlist') }, { children: loading ? ((0, jsx_runtime_1.jsx)(ui_1.LoadingGlobal, {})) : products.length > 0 ? ((0, jsx_runtime_1.jsx)(ProductsGrid, Object.assign({ gap: "small" }, { children: products.map((product) => ((0, jsx_runtime_1.jsx)(WishlistItem, { product: product }, product.id))) }))) : ((0, jsx_runtime_1.jsx)(EmptyInfo_1.EmptyInfo.Margin, { children: (0, jsx_runtime_1.jsx)(EmptyInfo_1.EmptyInfo, { svg: svg_1.SvgHeart, title: t('store.wishlistEmpty'), description: "" }) })) })));
}
exports.UserPanelWishlistView = UserPanelWishlistView;
